// Modal 遮罩「點外面關閉」的共用 handler。
//
// 為什麼不能直接寫 onClick={onClose}：瀏覽器的 click 事件是派給 mousedown 與 mouseup
// 兩個 target 的「最近共同祖先」。使用者在對話框的輸入框裡按住左鍵拖曳選字、放開時
// 游標滑到面板外（很容易發生，尤其是往左/往下拖），共同祖先就變成遮罩本身 →
// click 的 target === 遮罩 → onClose 被觸發 → 選個字對話框就整個關掉。
// 面板上的 stopPropagation 擋不住，因為事件本來就直接發生在遮罩上，沒有經過面板。
//
// 解法：只有「mousedown 和 mouseup 都確實落在遮罩上」才算點外面。
// 不用 useRef 是為了讓這個 helper 能在任何地方直接展開（含非 hook 的巢狀元件），
// 狀態改掛在 DOM 節點上（WeakMap，元素回收即釋放）。
//
// 用法：<div className="fixed inset-0 ..." {...overlayDismiss(onClose)}>
const armed = new WeakMap();

export function overlayDismiss(onClose) {
    return {
        onMouseDown: (e) => {
            armed.set(e.currentTarget, e.target === e.currentTarget);
        },
        onMouseUp: (e) => {
            // 從遮罩往面板內拖曳放開（例如拖選到一半滑進面板）同樣不該關閉
            if (e.target !== e.currentTarget) armed.set(e.currentTarget, false);
        },
        onClick: (e) => {
            const ok = armed.get(e.currentTarget) === true && e.target === e.currentTarget;
            armed.set(e.currentTarget, false);
            if (ok) onClose?.(e);
        },
    };
}
